angular.module('cimerFrontEndApp').controller('loginModalCtrl', ['$scope', '$uibModalInstance', 'Session', '$window',
    function ($scope, $uibModalInstance, Session, $window) {
        'use strict';
        $scope.cancel = function () {
            $uibModalInstance.dismiss('close');
        };

        $scope.createUser = function () {
            Session.redirectUrl = window.location.href;
            $uibModalInstance.dismiss('close');
            $window.location = '/#/register';
        };

        $scope.forgotPassword = function () {
            Session.redirectUrl = window.location.href;
            $uibModalInstance.dismiss('close');
            $window.location = '/#/forgotPassword';
        };

        $scope.loginPressed = false;
        $scope.login = function () {
            $scope.loginPressed = true;
            $scope.message = '';
            Session.authenticate($scope.credentials.username, $scope.credentials.password).then(function () {
                $uibModalInstance.close(true);
                $scope.loginPressed = false;
            }, function (responseData) {

                if (angular.isObject(responseData)) {

                    if (responseData.IsDeactivated) {
                        $scope.message = 'Your account has been deactivated. Please reset your password.';
                    } else if (responseData.IsLockedOut) {
                        $scope.message = 'Too many failed login attempts. Please reset your password or wait 10 minutes and try again.';
                    } else if (responseData.IsNotAllowed) {
                        $scope.message = 'Your user is not allowed to log in.';
                    } else {
                        $scope.message = 'Invalid email or password entered.';
                    }
                    
                } else {
                    $scope.message = 'Unknown error authenticating';
                }

                $scope.loginPressed = false;
            });
        };
    }]);